//we use this id for create unic name for multiselect
//only used for the ac selection
var radioUnicId = 0

// Comparte la distribucion y los eventos de abono de las facturas.
export function payment_vs_bounced_check(id) {
	return payment_vs_sale(id)
		.replace(/<div class="btn-item-info"[\s\S]*?<\/div>/, '')
		.replace(/\bsale_id\b/g, 'bounced_check_id')
		.replace(/\bpo_total_amount\b/g, 'total_amount')
		.replace('Po Total Amoun', 'Bank Fee')
}

export function payment_vs_sale(id){

	radioUnicId++
	return `

	<div class="line line-${id} " lineId="${id}" id="receivepayment_form_mt_${radioUnicId}">   

		<div class="btn-item-info" title="View associated sale" style="z-index: 200000001;" data-detail='{"click": [
			{"dest":"ripple"},
			{"dest":"receivepayment", "elem":"fullcont", "act":"jumperToSale"}
		]}'></div>

	    <div class="row" style="margin-left:24px;">
	 	

	<div class="c50">




 <div class="row">
 				<div class="c20">

					<div class="checkbox checkbox-mini " id="add_amount"> 
					<input type="checkbox" class="elem" data-detail='{"click":[{"dest":"ripple" },
								{"dest":"receivepayment", "elem":"fullcont",  "id":"receivepayment-fullcont", "act":"addAmount" , "line":"${radioUnicId}"}]}'> 
					<label>ADD</label>
				</div><!-- checkbox -->  

				</div><!-- c25 --> 
		
				<div class="c75">

					<div class="textfield  textfield-autocomplete textfield-autocomplete-mini textfield-autocomplete-disabled sale_id" id="receivepayment_form_saleid_mt_${radioUnicId}" selected = '[]'  max = '1'>

						<input autocomplete="off"  class= 'elem' type="text" 
							data-detail='{
							"key": [   {"dest":"textfield",    "act":"typing" }, 
										{"dest":"autocomplete", "act":"typing",  "entity": "sale", "mainFilter": ["code"], "parent": "receivepayment_form_saleid_mt_${radioUnicId}"   }],
							"click": [ {"dest":"autocomplete", "act":"click",   "entity": "sale", "mainFilter": ["code"], "parent": "receivepayment_form_saleid_mt_${radioUnicId}"   }]
							}' readonly>
							
						<div class="chip-cont"></div>
						<!-- otherField is used for autocomplete other fields, different than id and displayText -->  
						<div class="dn otherField" data-detail='{}' ></div>

					</div> <!-- textfield --> 

				</div><!-- c25 --> 
	</div><!-- row --> 





	</div><!-- c75 --> 



<div class="c50">
	   

 <div class="row">
			<div class="c33">

				<div class="textfield textfield-cash  textfield-mini textfield-disabled po_total_amount "  >

					<input autocomplete="off"  class= 'elem' type="text"  placeholder="Po Total Amoun" 
					data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

				</div><!-- textfield -->  

			</div><!-- c25 --> 

			<div class="c33">

				<div class="textfield textfield-cash  textfield-mini textfield-disabled due_amount"  >

					<input autocomplete="off"  class= 'elem' type="text" placeholder="Due Amount" 
					data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

				</div><!-- textfield -->  

			</div><!-- c25 --> 

			
			<div class="c33">

				<div class="textfield textfield-cash  textfield-mini sent_amount"  >

					<input autocomplete="off"  class= 'elem' type="text"  placeholder="Sent Amount" 
					data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  } ,
											 {"dest":"receivepayment", "elem":"fullcont",  "act":"verifyvalue","id_item_ac":"${radioUnicId}"} ] }' >

				</div><!-- textfield -->  

			</div><!-- c25 --> 
	</div><!-- row --> 




</div><!-- c25 --> 



	    </div><!-- row -->

	</div><!-- line -->  
	`

}


